export const clickables = [
  '.hoverable',
  '.arrow-section',
  '.general-about-section',
  '.markdown-section',
  '.menu-item',
  '.image-wrapper',
];